import classcat from "classcat";
import React, { useCallback } from "react";

import CheckCircleIcon from "@assets/icons/svgr/check-circle.svg";

import { DEVICE_ICONS } from "@is/constants";
import { Device } from "@is/types";

import css from "./DeviceItem.module.css";

type Props = {
  item: Device;
  isSelected: boolean;
  onClick: (device: Device) => void;
};

const DeviceItem = ({ item, isSelected, onClick }: Props) => {
  const handleClick = useCallback(() => {
    onClick(item);
  }, [item, onClick]);

  const Icon = DEVICE_ICONS[item.type];

  return (
    <div className={css.container} onClick={handleClick}>
      <div
        className={classcat([
          css.cardContainer,
          { [css.selected]: isSelected },
        ])}
      >
        <div className={css.iconContainer}>
          <Icon />
        </div>
        <div className="text-label-lg">{item.name}</div>
      </div>
      <div className={classcat(["text-button-base", css.description])}>
        {item.description}
      </div>
      {isSelected && (
        <div className={css.checkIconContainer}>
          <CheckCircleIcon />
        </div>
      )}
    </div>
  );
};

export default DeviceItem;
